import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class UserModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (UserModel._instance == null) UserModel._instance = new UserModel(authManager);
        return UserModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/users', 'core/users/codelist');

        this.entityName = 'core.User';
        this.privileges = {
            create: [["adminUsers"],["manageUsers"]],
            read: [["adminUsers"],["manageUsers"],["editUsers"],["readUsers"]],
            update: [["adminUsers"],["manageUsers"],["editUsers"]],
            delete: [["adminUsers"],["manageUsers"]],
        };

        this.label = 'User';
        this.setLabel = 'Users';

        this.browser = {
            name: 'default-core-user-browser',
            moduleName: 'default-core-user-browser',
            moduleTitle: 'Users',
            moduleStateSlotName: 'default-core-user-browser',
        };

        this.editor = {
            name: 'default-core-user-editor',
            moduleName: 'default-core-user-editor',
            moduleTitle: 'User',
            moduleStateSlotName: 'default-core-user-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'username',
                type: 'string',
                persistent: true,
                label: 'Přihlašovací jméno',
                required: true,
            },
            {
                name: 'isLocked',
                type: 'bool',
                persistent: true,
                label: 'Je uzamčen',
            },
            {
                name: 'isSysAdmin',
                type: 'bool',
                persistent: true,
                label: 'Je systémový administrátor',
            },
            {
                name: 'email',
                type: 'string',
                persistent: true,
                label: 'E-mail',
                required: true,
            },
            {
                name: 'firstName',
                type: 'string',
                persistent: true,
                label: 'Jméno',
            },
            {
                name: 'lastName',
                type: 'string',
                persistent: true,
                label: 'Příjmení',
            },
            {
                name: 'phone',
                type: 'string',
                persistent: true,
                label: 'Telefonní číslo',
            },
            {
                name: 'twoFactorEnabled',
                type: 'bool',
                persistent: true,
                label: 'Dvoufaktorové přihlašování zapnuto',
            },
            {
                name: 'homeFolderId',
                type: 'Folder',
                persistent: true,
                label: 'Home Folder',
                inEditor: true,
            },
            {
                name: 'createdAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Created At',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'updatedAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Changed At',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'lockedAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Uzamčeno',
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
